import { Skeleton, styled } from '@mui/material'
import { Box } from '@mui/material'

const StyledAvatarContainer = styled(Box)({
    backgroundColor: '#eef0f4',
    width: '82px',
    height: '82px',
    position: 'absolute',
    top: '-41px',
    left: '83px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
})

const StyledAttributeContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    '& span': {
        margin: '6px 0px',
    },
})

const StyledSkeleton = styled(Skeleton)({
    height: '62px',
    width: '62px',
    backgroundColor: '#bdbdbd',
})

const StyledCard = styled(Box)({
    position: 'relative',
    width: 248,
    height: 248,
    margin: '10px',
    padding: '20px',
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 4px 16px 0px',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    paddingTop: '80px',
})

export const OrgChartSkeleton = ({ ...rest }: any) => {
    const card = (
        <StyledCard {...rest}>
            <StyledAvatarContainer>
                <StyledSkeleton variant="circular" animation="wave" />
            </StyledAvatarContainer>

            <StyledAttributeContainer>
                <Skeleton variant="text" animation="wave" height={28} />
                <Skeleton variant="text" animation="wave" height={28} />
                <Skeleton variant="text" animation="wave" height={28} />
            </StyledAttributeContainer>
        </StyledCard>
    )

    return (
        <Box
            height="80%"
            display="flex"
            width="100%"
            marginTop="200px"
            justifyContent="center"
        >
            <Box width="70%">
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    marginBottom="70px"
                >
                    {card}
                </Box>

                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-around"
                >
                    {card}
                    {card}
                    {card}
                </Box>
            </Box>
        </Box>
    )
}
